<template>
  <div class="stock-detail">
    <Header title="个股龙虎榜"></Header>
    <div class="container"  :class="{'safari-container': isSafari}">
      <div class="intro">
      <div>
        <div class="name">{{ stockDetail.chiNameAbbr }}</div>
        <div class="code">{{ stockDetail.secuCode }}</div>
      </div>
      <div>
        <div class="date">{{ stockDetail.tradingDay }}</div>
        <div class="code text-right">最近上榜</div>
      </div>
    </div>
    <div class="reason">
      <div class="title">当日上榜原因：</div>
      <div class="description">
        {{ stockDetail.abnormalTypeInfo }}
      </div>
    </div>
    <div class="reason-list" v-if="stockDetail.stockRankList && stockDetail.stockRankList.length">
      <div class="reason-iterm" v-for="(iterm, key) in stockDetail.stockRankList" :key="key">
        <div class="reason-head">
          <img class="reward" src="../../../assets/reward.png">
          <div class="sbang-reason">上榜原因：{{ iterm.abnormalTypeInfo }}</div>
        </div>
        <div class="buy">
          <div class="dot"></div>
          <div class="buy-text">买入前五营业部</div>
        </div>
        <div class="table-title">
          <div class="department-name">营业部名称</div>
          <div class="buy-sale">买入/卖出</div>
          <div class="properties">营业部性质</div>
        </div>
        <div class="dep-list" v-if="iterm.buyRank && iterm.buyRank.length">
          <div class="dep-info" v-for="(v, k) in iterm.buyRank" :key="k" @click="$router.push(`/department/detail/${v.departmentId}.html`)">
            <div class="dep-name">
              <div class="com-name">{{ v.departmentName }}</div>
              <div class="address" v-if="v.factionName">{{ v.factionName }}</div>
            </div>
            <div class="buy-sale-data">
              <div class="red-text">{{ v.buySum | formatUnit }}</div>
              <div class="green-text">{{ v.saleSum | formatUnit }}</div>
            </div>
            <div class="seat">{{ v.natureName }}</div>
          </div>
        </div>
        <div class="buy">
          <div class="dot"></div>
          <div class="buy-text">卖出前五营业部</div>
        </div>
        <div class="table-title">
          <div class="department-name">营业部名称</div>
          <div class="buy-sale">买入/卖出</div>
          <div class="properties">营业部性质</div>
        </div>
        <div class="dep-list" v-if="iterm.saleRank && iterm.saleRank.length">
          <div class="dep-info" v-for="(v, k) in iterm.buyRank" :key="k" @click="$router.push(`/department/detail/${v.departmentId}.html`)">
            <div class="dep-name">
              <div class="com-name">{{ v.departmentName }}</div>
              <div class="address" v-if="v.factionName">{{ v.factionName }}</div>
            </div>
            <div class="buy-sale-data">
              <div class="red-text">{{ v.buySum | formatUnit }}</div>
              <div class="green-text">{{ v.saleSum | formatUnit }}</div>
            </div>
            <div class="seat">{{ v.natureName }}</div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import Header from '../header.vue';
import {request} from '@/api/request';
import {formatUnit} from '@/utils/formatUnit'
import SafariAdapter from '../mixin/safari-adapter-mixin';
export default {
  mixins: [SafariAdapter],
  components: {
    Header
  },
  data() {
    return {
      secuCode: this.$route.params.id,
      stockDetail: {
        buyRank: [],
        saleRank: []
      }
    }
  },
  async created() {
    this.stockDetail = await this.getStockDetail();
  },
  methods: {
    async getStockDetail() {
      return await request.get({
        url: request.apis.rank.stockDetail,
        params: {
          secuCode: this.secuCode
        }
      }); 
    }
  },
  filters: {
    formatUnit(num) {
      if(!num) return 0;
      return formatUnit(num);
    }
  }
}
</script>

<style lang="stylus" src="./stock-detail.styl" scoped></style>>